import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Col, Radio, Row } from "antd";
import FilterPanel from "../../components/common/filterPanel";
import { useEffect, useState } from 'react';
import subProjectService from "../../services/subProjectService";
import SubProjectResultsDataTable from "../../components/vendor/subProjectResultsDataTable";
import { convertSelFilterValBusinessToLuObj, convertSelFilterValToLuObj, convertSelFilterValToLuObjUser } from "../../utils/commonUtil";
import { formatDate } from "../../utils/commonUtil";
import { useDispatch, useSelector } from "react-redux";
import { setKeywordSearchStr } from "../../context/reducers/userReducer";
import commonService from "../../services/CommonService";
import { UserActivity } from "../../config/BVConstants";
const SubProjectSearch = () => {
    var _a, _b;
    const [firstLoad, setFirstLoad] = useState(0);
    const [selSubPrjStatus, setSelSubPrjStatus] = useState([]);
    const [selEntity, setSelEntity] = useState([]);
    const [selCountry, setSelCountry] = useState([]);
    const [selBvContact, setSelBvContact] = useState([]);
    const [selProductSubsegmentList, setSelProductSubsegmentList] = useState([]);
    const [selServiceTypeList, setSelServiceTypeList] = useState([]);
    const [selLstBVLocation, setSelLstBVLocation] = useState([]);
    const [selLstTechType, setSelLstTechType] = useState([]);
    const [radioBtnValue, setRadioBtnValue] = useState();
    const [loading, setLoading] = useState(false);
    const [selSubProjectAssignedStartDate, setSelSubProjectAssignedStartDate] = useState([undefined, undefined]);
    const [selActualCompletionDate, setSelActualCompletionDate] = useState([undefined, undefined]);
    const [selVendorStartDate, setSelVendorStartDate] = useState([undefined, undefined]);
    const [selVendorPlannedCompletionDate, setSelVendorPlannedCompletionDate] = useState([undefined, undefined]);
    const [subPrjDataList, setSubPrjDataList] = useState();
    const [strSearchBoxText, setStrSearchBoxText] = useState();
    const applicationData = useSelector((state) => state.applicationData);
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    useEffect(() => {
        var _a, _b, _c, _d;
        if ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId) {
            commonService
                .logUserActivity((_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserEmailId, UserActivity.VP__Sub_Project_Visited);
        }
    }, [(_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId]);
    useEffect(() => {
        var _a, _b;
        setSubPrjDataList([]);
        const firstPage = pagination.current == 1 ? pagination.current : ((pagination.current * 10) - 10) + 1;
        const lastPage = pagination.current == 1 ? pagination.pageSize : (pagination.current * 10);
        const subPrjReqObj = {
            intProjectNewOrRenewalFlag: null,
            objLoggedinUser: {
                objUser: {
                    intId: applicationData === null || applicationData === void 0 ? void 0 : applicationData.companyId
                }
            },
            lstLuCompany: convertSelFilterValToLuObj(selEntity),
            lstSubProjectStatus: convertSelFilterValToLuObj(selSubPrjStatus),
            lstCountries: convertSelFilterValToLuObj(selCountry),
            lstAssignedTo: convertSelFilterValToLuObjUser(selBvContact),
            lstServiceType: convertSelFilterValToLuObj(selServiceTypeList),
            lstTechType: convertSelFilterValToLuObj(selLstTechType),
            lstProductType: convertSelFilterValToLuObj(selProductSubsegmentList),
            lstEntity: convertSelFilterValBusinessToLuObj(selLstBVLocation),
            strSearchBoxText: strSearchBoxText,
            dtVendorAssignFromDate: formatDate(selSubProjectAssignedStartDate && selSubProjectAssignedStartDate[0] ? selSubProjectAssignedStartDate[0].format('YYYY-MM-DD') : null),
            dtVendorAssignToDate: formatDate(selSubProjectAssignedStartDate && selSubProjectAssignedStartDate[1] ? selSubProjectAssignedStartDate[1].format('YYYY-MM-DD') : null),
            dtSubProjActCompetionDateFrom: formatDate(selActualCompletionDate && selActualCompletionDate[0] ? selActualCompletionDate[0].format('YYYY-MM-DD') : null),
            dtSubProjActCompetionDateTo: formatDate(selActualCompletionDate && selActualCompletionDate[1] ? selActualCompletionDate[1].format('YYYY-MM-DD') : null),
            dtSubProjVendorStartDateFrom: formatDate(selVendorStartDate && selVendorStartDate[0] ? selVendorStartDate[0].format('YYYY-MM-DD') : null),
            dtSubProjVendorStartDateTo: formatDate(selVendorStartDate && selVendorStartDate[1] ? selVendorStartDate[1].format('YYYY-MM-DD') : null),
            dtSubProjVenPlannedCompDateFrom: formatDate(selVendorPlannedCompletionDate && selVendorPlannedCompletionDate[0] ? selVendorPlannedCompletionDate[0].format('YYYY-MM-DD') : null),
            dtSubProjVenPlannedCompDateTo: formatDate(selVendorPlannedCompletionDate && selVendorPlannedCompletionDate[1] ? selVendorPlannedCompletionDate[1].format('YYYY-MM-DD') : null),
            intToPage: lastPage,
            intFromPage: firstPage,
        };
        setLoading(true);
        subProjectService.searchVendorSubProjectsCount(subPrjReqObj).then((res) => {
            setPagination(prev => (Object.assign(Object.assign({}, prev), { total: res })));
        });
        if (firstLoad == 0) {
            subProjectService.getVendorWOStatusByOrder(subPrjReqObj).then((response) => {
                setFirstLoad(1);
                processStatusChange(response === null || response === void 0 ? void 0 : response.toString());
                setLoading(false);
            });
        }
        else {
            subProjectService.searchVendorSubProjects(subPrjReqObj).then((response) => {
                setSubPrjDataList(response);
                setLoading(false);
            });
            commonService
                .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.VP__Sub_Project_Search);
        }
    }, [
        selSubPrjStatus,
        selEntity,
        selCountry,
        selBvContact,
        selLstTechType,
        selLstBVLocation,
        selServiceTypeList,
        selProductSubsegmentList,
        selSubProjectAssignedStartDate,
        selActualCompletionDate,
        selVendorStartDate,
        selVendorPlannedCompletionDate,
        strSearchBoxText,
        pagination.current,
        pagination.pageSize,
    ]);
    useEffect(() => {
        if (applicationData.keywordSearchStr) {
            handleClearAllAppliedFilters();
            setStrSearchBoxText(applicationData.keywordSearchStr);
            dispatch(setKeywordSearchStr(''));
        }
    }, [applicationData.keywordSearchStr]);
    const handleClearAllAppliedFilters = () => {
        setSelSubPrjStatus([]);
        setSelEntity([]);
        setSelCountry([]);
        setSelBvContact([]);
        setSelProductSubsegmentList([]);
        setSelServiceTypeList([]);
        setSelLstBVLocation([]);
        setSelLstTechType([]);
        setSelSubProjectAssignedStartDate([undefined, undefined]);
        setSelVendorStartDate([undefined, undefined]);
        setSelActualCompletionDate([undefined, undefined]);
        setSelVendorPlannedCompletionDate([undefined, undefined]);
        setStrSearchBoxText('');
    };
    const prjFilterSectionData = subProjectService.getVendorSubPrjFilterSectionData(applicationData, selSubPrjStatus, (val) => setSelSubPrjStatus(val), selEntity, (val) => setSelEntity(val), selLstBVLocation, (val) => setSelLstBVLocation(val), selCountry, (val) => setSelCountry(val), selBvContact, (val) => setSelBvContact(val), selServiceTypeList, (val) => setSelServiceTypeList(val), selProductSubsegmentList, (val) => setSelProductSubsegmentList(val), selLstTechType, (val) => setSelLstTechType(val), selSubProjectAssignedStartDate, (val) => setSelSubProjectAssignedStartDate(val), selVendorStartDate, (val) => setSelVendorStartDate(val), selActualCompletionDate, (val) => setSelActualCompletionDate(val), selVendorPlannedCompletionDate, (val) => setSelVendorPlannedCompletionDate(val), handleClearAllAppliedFilters);
    const handleRadioBtnChange = (e) => {
        let statusData = e.target.value;
        processStatusChange(statusData);
    };
    const processStatusChange = (statusData) => {
        setRadioBtnValue(statusData);
        if (statusData === null || statusData === void 0 ? void 0 : statusData.includes('-')) {
            const splitStatusData = statusData.split('-');
            setSelSubPrjStatus([splitStatusData[0], splitStatusData[1]]);
        }
        else {
            setSelSubPrjStatus([statusData]);
        }
    };
    const handleTableChange = (pagination) => {
        setPagination(prev => (Object.assign(Object.assign({}, prev), { current: pagination.current, pageSize: pagination.pageSize })));
    };
    return (_jsx(Row, { gutter: [16, 16], children: _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, children: _jsxs(Row, { gutter: [16, 16], children: [_jsx(Col, { xs: 24, sm: 24, md: 24, lg: 6, xl: 5, children: _jsx(FilterPanel, { data: prjFilterSectionData }) }), _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 18, xl: 19, children: _jsx(Row, { gutter: [16, 16], children: _jsxs(Col, { xs: 24, children: [_jsx(Card, { style: { marginBottom: '10px', fontSize: '5px' }, children: _jsxs(Radio.Group, { onChange: handleRadioBtnChange, value: radioBtnValue, children: [_jsx(Radio, { value: '4030', style: { fontSize: '11px' }, children: "Testing in Progress" }), _jsx(Radio, { value: '4040', style: { fontSize: '11px' }, children: "Submission Complete" }), _jsx(Radio, { value: '4050', style: { fontSize: '11px' }, children: "Application under review by Authority" }), _jsx(Radio, { value: '4060', style: { fontSize: '11px' }, children: "Certificate Received" }), _jsx(Radio, { value: '4005-4004', style: { fontSize: '11px' }, children: "On Hold/Stopped" }), _jsx(Radio, { value: '4003-4006', style: { fontSize: '11px' }, children: "Complete/Cancelled" })] }) }), _jsx(SubProjectResultsDataTable, { dataSource: subPrjDataList, loading: loading, pagination: pagination, onChange: handleTableChange })] }) }) })] }) }) }));
};
export default SubProjectSearch;
